import React from 'react';
import { abbreviateNumber } from '../utils/abbreviateNumber.js';

const ValueCard = ({ title, value, color, length, change }) => {
  return (
    <div
      className={`text-center md:text-left w-full md:w-1/3 lg:w-full bg-white rounded-md flex-grow`}
    >
      <div className="w-full h-full flex flex-col justify-center overflow-hidden p-4">
        <h3 className="font-mono text-sm">
          {title} {length}
        </h3>
        <h2 className={`pt-2 font-medium text-3xl ${color}`}>
          ${abbreviateNumber(value).replace(/(?=.{1}$)/,' ')}
          <span className="font-mono font-bold text-sm text-green-500">
            {' '}
            (+{change}%)
          </span>
        </h2>
      </div>
    </div>
  );
};

export default ValueCard;
